/* eslint-disable quotes */
import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  confirmHeader: {
    id: 'learner-dash.unenrollConfirm.delete.course',
    description: 'Header for confirm Delete course',
    defaultMessage: 'Are You Sure want to Delete the course ',
  },
  confirmCancel: {
    id: 'learner-dash.unenrollConfirm.delete.course',
    description: 'Cancel action for confirm unenroll modal',
    defaultMessage: 'Cancel',
  },
  confirmDelete: {
    id: 'learner-dash.unenrollConfirm.delete.course',
    description: 'Confirm action for delete course',
    defaultMessage: 'Delete',
  },
});

export default messages;
